export const timeDistance = (durationMs1: number, durationMs2 = 0) => {
  let distance = Math.abs(durationMs1 - durationMs2)
  const hours = Math.floor(distance / 3600000)
  distance -= hours * 3600000
  const minutes = Math.floor(distance / 60000)
  distance -= minutes * 60000
  const seconds = Math.floor(distance / 1000)
  return `${hours}:${("0" + minutes).slice(-2)}:${("0" + seconds).slice(-2)}`
}
